import React, { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Helpers } from '../helpers/Helpers';
import { MrzResponse } from '../models/response/mrz/MrzResponse';
import { storeActivityIndicator } from '../redux/reducers/authSlice';
import { RootState } from '../redux/store';
import Box from './Box';
import toast from "react-hot-toast";
import { AddDriverByMrzResponse, AddDriverByMrzResponseData } from '../models/response/driver/AddDriverByMrzResponse';
import { DriverService } from '../services/DriverService';

interface Props {
    callback: (response: AddDriverByMrzResponseData) => void
    closeLoadingAfter: boolean
}

const DriverMrzNfc = ({ callback, closeLoadingAfter }: Props) => {
    useEffect(() => {
        return () => {
            if (socketRef.current) {
                socketRef.current.close();
            }
        };
    }, []);

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const socketRef = useRef<WebSocket | null>(null);
    const [isListening, setIsListening] = useState(false);

    const disconnectSocket = () => {
        if (socketRef.current) {
            socketRef.current.close();
            socketRef.current = null;
        }
    };

    const mrzNfcHandler = async () => {
        if (socketRef.current) {
            return;
        }

        setIsListening(true);

        const socket = new WebSocket(Helpers.getWsEndpoint() + '/ws');
        socketRef.current = socket;

        socket.onopen = () => {
            socket.send("MRZ-" + auth.user.user?.data.id);
        };

        socket.onmessage = async (event) => {
            try {
                setIsListening(false);
                dispatch(storeActivityIndicator(true));
                const data: MrzResponse = JSON.parse(event.data);
                socket.close();
                var response: AddDriverByMrzResponse = await DriverService.addDriverByMrz(data);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                if (closeLoadingAfter)
                    dispatch(storeActivityIndicator(false));

                callback(response.data);
            } catch (error: any) {
                toast.error(error);
                dispatch(storeActivityIndicator(false));
            }
        };

        socket.onclose = () => {
            socketRef.current = null;
            setIsListening(false);
        };

        socket.onerror = (error) => {
        };
    }

    return (
        <React.Fragment>
            {
                auth.user.user?.data.roles.find(x => x == "MRZ & NFC İşlemi Yetkisi") && (
                    <Box ml='10px' justifyContent='center'>
                        {
                            !isListening ? (
                                <Box onClick={mrzNfcHandler} className='actionIcon bg-primary' borderRadius='0.425rem' p='7.5px' justifyContent='center' flexDirection='row'>
                                    <Box justifyContent='center'>
                                        <i style={{ color: 'white', fontSize: '12px' }} className='fa fa-wifi' />
                                    </Box>
                                    <Box ml='5px' justifyContent='center'>
                                        <span style={{ color: 'white', fontSize: '12px' }}>MRZ & NFC</span>
                                    </Box>
                                </Box>
                            ) : (
                                <Box onClick={disconnectSocket} className='actionIcon bg-danger' borderRadius='0.425rem' p='7.5px' justifyContent='center' flexDirection='row'>
                                    <Box justifyContent='center'>
                                        <i style={{ color: 'white', fontSize: '12px' }} className='fa fa-times' />
                                    </Box>
                                    <Box ml='5px' justifyContent='center'>
                                        <span style={{ color: 'white', fontSize: '12px' }}>İptal Et</span>
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>
                )
            }
        </React.Fragment>
    )
}

export default DriverMrzNfc;